export default "__VITE_ASSET__C0xDE$F8__"